export default __webpack_public_path__ + "static/media/email.507e95b6.svg";